import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatPaginator } from '@angular/material/paginator';
import { InsuranceService } from '../insurance.service';
import { FeeScheduleService } from '../../fee-schedule/services/fee-schedule.service';
import {PatientInsuranceDataModel} from '../../../models/patient/patient-insurance-data.model';
import {
  PatientInsuranceCoverageListViewModel, PatientInsuranceCoverageSaveModel

} from '../models/patient-insurance-coverage-list-view.model';
import {EnumValidValueItemModel} from '../../../models/enum/enum-valid-value-item.model';
import {StaticDataService} from '../../../services/static-data.service';
import {TdoTableSelectionEvent} from '../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {DxDataGridComponent} from "devextreme-angular";

@Component({
    selector: 'app-insurance-coverage',
    templateUrl: './insurance-coverage.component.html',
    styleUrls: ['./insurance-coverage.component.css']
})

export class InsuranceCoverageComponent implements OnInit {

    @ViewChild('paginator') paginator: MatPaginator;
    @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;

    searchPredicate: (data: any, filter: string) => boolean;
    isLoading: boolean = true;
    dataPatientInsurance: PatientInsuranceDataModel;
    organizationID: string;
    insuranceDescription: string;
    coverages: PatientInsuranceCoverageListViewModel[] = [];
    changesMade: boolean = true;
    enumCoverageTypes: EnumValidValueItemModel[] = [];

    enumCalcTypePerc: string = '00000048-1000-0000-0000-000000000001';
    enumCalcTypeMoney: string = '00000048-1000-0000-0000-000000000002';

    enumFeeItemCategoryA: string = '00000047-1000-0000-0000-000000000001';
    enumFeeItemCategoryB: string = '00000047-1000-0000-0000-000000000002';
    enumFeeItemCategoryC: string = '00000047-1000-0000-0000-000000000003';
    enumFeeItemCategories: EnumValidValueItemModel[] = [];

    updateWizardA: number;
    updateWizardB: number;
    updateWizardC: number;

    constructor(
        private dialogRef: MatDialogRef<InsuranceCoverageComponent>,
        private insuranceService: InsuranceService,
        private feeScheduleService: FeeScheduleService,
        private snackBar: MatSnackBar,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private staticDataService: StaticDataService
    ) {
        this.searchPredicate = (searchData: PatientInsuranceCoverageListViewModel, filter: string) => {
            if ((!searchData.Code ? '' : searchData.Code).toLowerCase().includes(filter)) {
                return true;
            }
            else if ((!searchData.Description ? '' : searchData.Description).toLowerCase().includes(filter)) {
                return true;
            }
            else if ((!searchData.FeeItemCategory ? '' : searchData.FeeItemCategory).toLowerCase().includes(filter)) {
                return true;
            }
            else {
                return false;
            }
        };
    }

    ngOnInit() {

        this.dataPatientInsurance = this.data.dataPatientInsurance;
        this.organizationID = this.data.OrganizationID;
        this.insuranceDescription = this.data.Description;

        const promises = [
            this.getPatientInsuranceCoveragesForInsurance(),
            this.getCoverageTyps(),
            this.getEnumFeeItemCategories()
        ];

        this.isLoading = true;
        Promise.all(promises)
            .then((results: any[]) => {
                this.coverages = results[0];
                this.enumCoverageTypes = results[1];
                this.enumFeeItemCategories = results[2];
                if (this.coverages.length === 0) {
                    this.showMessage('Error', 'No fee schedules found for this carrier. Please add a fee schedule in the fee schedule manager.');
                }

                this.coverages.forEach(coverage => {
                    if (!coverage.CoverageAmount) {
                        coverage.CoverageAmount = 0;
                    }
                    if (!coverage.CoveragePCT) {
                        coverage.CoveragePCT = 0;
                    }
                });

                this.isLoading = false;
            }, err => {
                console.log(err);
                this.showMessage('Error', 'Error fetching coverages');
                this.isLoading = false;
            });
    }

    getCoverageTyps() {
        const promise = new Promise((resolve, reject) => {
            this.feeScheduleService.getFeeCoveragesCalcTypes()
                .subscribe(response => {
                    resolve(response);
                }, err => {
                    reject(err);
                });
        });
        return promise;
    }

    getEnumFeeItemCategories() {
        const promise = new Promise((resolve, reject) => {
            this.feeScheduleService.getEnumValidValueItemsByVVName('enumFeeItemCategoryId')
                .subscribe(response => {
                    resolve(response.enumValidValueItems);
                }, err => {
                    reject(err);
                });
        });
        return promise;
    }

    getPatientInsuranceCoveragesForInsurance() {
        const promise = new Promise((resolve, reject) => {
            this.insuranceService.getPatientInsuranceCoveragesForInsurance(this.dataPatientInsurance.InsuranceID)
                .subscribe(response => {
                    resolve(response);
                }, err => {
                    reject(err);
                });
        });
        return promise;
    }

    cancel() {

      const currentState = this.dataGrid.instance.hasEditData();

      if(currentState==true)
      {
        this.showMessage('WARNING', 'Some Data is not saved. Please save your changes or discard your changes.');
        return;
      }


        this.dialogRef.close(false);
    }

    saveChanges() {
      this.dataGrid.instance.refresh();
      return;
    }

    saveCoverage(coverage) {
        const promise = new Promise((resolve, reject) => {
            this.feeScheduleService.saveFeeScheduleCoverage(coverage)
                .subscribe(response => {
                    resolve(response);
                }, err => {
                    reject(err);
                });
        });
        return promise;
    }

    showMessage(type, message) {
        this.snackBar.open(message, type, {
            duration: 3000,
            verticalPosition: 'top'
        });
    }

    applyWizard() {
    // this.coverages
        if (this.updateWizardA > 0) {
            this.coverages.forEach(a => {
                if (a.enumFeeCoverageCalcTypeId === this.enumCalcTypePerc && a.enumFeeItemCategoryId === this.enumFeeItemCategoryA) {
                    a.CoveragePCT = this.updateWizardA;
                    a.changed = true;
                    this.changesMade = true;
                }
            });
        }

        if (this.updateWizardB > 0) {
            this.coverages.forEach(a => {
                if (a.enumFeeCoverageCalcTypeId === this.enumCalcTypePerc && a.enumFeeItemCategoryId === this.enumFeeItemCategoryB) {
                    a.CoveragePCT = this.updateWizardB;
                    a.changed = true;
                    this.changesMade = true;
                }
            });
        }

        if (this.updateWizardC > 0) {
            this.coverages.forEach(a => {
                if (a.enumFeeCoverageCalcTypeId === this.enumCalcTypePerc && a.enumFeeItemCategoryId === this.enumFeeItemCategoryC) {
                    a.CoveragePCT = this.updateWizardC;
                    a.changed = true;
                    this.changesMade = true;
                }
            });
        }

        this.insuranceService.getPatientInsuranceCoveragesForInsuranceApplyDisc(this.dataPatientInsurance.InsuranceID, this.updateWizardA, this.updateWizardB, this.updateWizardC).subscribe(res => {



        });


    }

    overrideOnToolbarPreparing(e) {


    }


  onSavingOnTable(e : any)
  {
    const s : PatientInsuranceCoverageSaveModel[] = [];
    const c = e.changes;
    c.forEach(a => {

      const r= this.coverages.find(f=> f.CoverageID == a.key);
      //console.log('ori record',r);

      s.push( {
        CoverageID : a.data.CoverageID  === undefined ? r.CoverageID : a.data.CoverageID,
        CoveragePCT :  a.data.CoveragePCT ===undefined ? r.CoveragePCT : a.data.CoveragePCT,
        isInclusive : a.data.isInclusive === undefined ? r.isInclusive : a.data.isInclusive,
        isNotCovered : a.data.isNotCovered === undefined ? r.isNotCovered : a.data.isNotCovered,

        InsuranceID: '',
        Code: r.Code,
        enumFeeItemCategoryId: '',
        FeeItemCategory: '',
        Description: '',

        CoverageAmount: 0,
        enumFeeCoverageCalcTypeId: '',

      });

    });
    this.insuranceService.savePatientInsuranceCoveragesForInsurance(s).subscribe(ret=> {
    });
  }


    overrideOnValueChangedTable(e) {


        if (e.dataField === 'Description') {
                //e.editorOptions.disabled = true;
        }
        if (e.dataField === 'Code') {
                //e.editorOptions.disabled = true;
        }
        if (e.dataField === 'enumFeeItemCategoryId') {
            //e.editorOptions.disabled = true;
        }






    }


    checkedNCValue(rowData) {

        // console.log(rowData);

        if ( rowData.isNotCovered == null) {
            return false;
        }
        return rowData.isNotCovered;

    }

    checkedIncValue(rowData) {
        if ( rowData.isInclusive == null) {
            return false;
        }
        return rowData.isInclusive;

    }


    returnEnumFeeItemCategoryCell(cellInfo: any) {
    // console.log('cellInfo', cellInfo);

        if (cellInfo.enumFeeItemCategoryId === null) {
            return '';
        }
        // console.log('cats', this.enumFeeItemCategories);


        const category = this.enumFeeItemCategories.find(a => a.ValidValueItemId === cellInfo.enumFeeItemCategoryId
        );

        // console.log('category', category);

        if (category) {
            return category.ItemDisplayValue;
        }
        else {
            return '';
        }
    }


    returnEnumFeeItemCategory(enumFeeItemCategoryId: string) {
        const category = this.enumFeeItemCategories.find(a => a.ValidValueItemId === enumFeeItemCategoryId);
        if (category) {
            return category.ItemDisplayValue;
        }
        else {
            return '';
        }
    }

    onCoverageAmountChange(coverage: PatientInsuranceCoverageListViewModel, event) {
        const inputValue = event.target.value;
        const numberValue = Number(inputValue.replace(/[^0-9.-]+/g, ''));

        coverage.CoverageAmount = numberValue;
    }

    onRowSelected($event: TdoTableSelectionEvent) {

    }
}
